export interface StipulationListKeyArguments {
  approvalId: string;
  openOnly?: boolean;
}

export interface StipulationHistoryKeyArguments {
  approvalId: string;
  stipCode: string;
  applicantPk?: number;
}

/**
 * Hierarchical query-key factory for the stipulations feature. The
 * shape encodes the cache hierarchy: invalidating `all` flushes every
 * stipulation query, `lists()` only flushes list queries, `detail(id)`
 * flushes a single record. Never write a literal key array outside
 * this module — the factory IS the schema.
 *
 * The list key includes `openOnly` because it is a real server-side
 * filter on the BFF (GET .../stipulations?openOnly=…): open-only and
 * full lists are distinct server payloads and must not share a cache
 * entry.
 */
export const stipulationKeys = {
  all: ["stipulations"] as const,
  lists: () => [...stipulationKeys.all, "list"] as const,
  list: (arguments_: StipulationListKeyArguments) => [...stipulationKeys.lists(), arguments_] as const,
  details: () => [...stipulationKeys.all, "detail"] as const,
  detail: (id: string) => [...stipulationKeys.details(), id] as const,
  histories: () => [...stipulationKeys.all, "history"] as const,
  history: (arguments_: StipulationHistoryKeyArguments) => [...stipulationKeys.histories(), arguments_] as const,
};
